import { render } from "./PassengerEditModal.vue?vue&type=template&id=3a600fec&scoped=true"
import script from "./PassengerEditModal.vue?vue&type=script&lang=js"
export * from "./PassengerEditModal.vue?vue&type=script&lang=js"

import "./PassengerEditModal.vue?vue&type=style&index=0&id=3a600fec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a600fec"]])

export default __exports__